import React from 'react';
import { connect } from 'react-redux';
import { statusPortaluser } from './redux/reduxApi';
import { closeModal } from '../../../app/modals/redux/modalActions';
import Modal from '../../../ui/Modal';
import Button from '../../../ui/Button';

const actions = {
  closeModal,
  statusPortaluser,
};

function ModalStatus({ data, closeModal, statusPortaluser }) {
  const { auth, history, item } = data;

  function setStatus() {
    const values = { ...item, status: item.status ? false : true };
    statusPortaluser({auth, history, values});
    closeModal();
  }

  return (
    <Modal variant='info' closeModal={closeModal}>
      <p className='my-3 mx-1'>
        Apakah Anda ingin set portal user{' '}
        <span className='has-text-danger has-text-weight-semibold is-capitalized'>
          {item.title}
        </span>{' '}
        menjadi {item.status ? 'tidak aktif' : 'aktif'} ?
      </p>
      <div className='flex justify-end align-center pt-2'>
        <div className='buttons'>
          <Button cvariant='csave' onClick={setStatus} />
          <Button cvariant='cback' onClick={closeModal} />
        </div>
      </div>
    </Modal>
  );
}

export default connect(null, actions)(ModalStatus);
